import { useContext, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { v4 as uuidv4 } from 'uuid';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext
} from '../../WorkflowEngine/workflowEngineReducer';
import ControlKind from '../../Shared/controlKind';
import ControlState from '../../Shared/controlState';
import PageState from '../../Shared/pageState';
import isBuilding from '../../Shared/jsonSchemaUtilities/isBuilding';
import { ListItemButton, ListItemIcon, Tooltip } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DragTypes } from '../../DragAndDrop';
import getLatestSchema from './schema';

export default () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);
  const { pages } = state;
  const { enqueueSnackbar } = useSnackbar();

  const handleDateClick = () => {
    if (isBuilding(pages)) {
      enqueueSnackbar('One control can be built at a time.', {
        variant: 'warning'
      });
      return;
    }

    const lastPage = pages[pages.length - 1] as PageState;

    const controlId = `control-${uuidv4()}`;
    const pageExternalId = lastPage.id;
    const order = Object.keys(lastPage.schema.properties as object).length - 1;

    const controlSchema = getLatestSchema(controlId, pageExternalId, order);

    dispatch({
      type: WorkflowEngineActionKind.CONTROL_ADD,
      payload: {
        id: controlId,
        building: true,
        pageId: lastPage.id,
        schema: controlSchema,
        kind: ControlKind.DATE
      } as ControlState
    });
  };

  const [, drag, preview] = useDrag(
    () => ({
      type: DragTypes.PALETTE_CONTROL,
      item: { type: ControlKind.DATE }
    }),
    []
  );

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
      <Tooltip title="Date Field" placement="right" disableInteractive>
    <ListItemButton onClick={handleDateClick} ref={drag}>
      <ListItemIcon style={{ minWidth: 'auto' }}>
        <CalendarMonthIcon />
      </ListItemIcon>
    </ListItemButton>
    </Tooltip>
  );
};
